<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 id="retur-title" class="mb-0"><i class="fa fa-fw fa-arrow-left mr-2" />Daftar Retur</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur Invoice Retur">
                        <b-form-input id="input-no-faktur" v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Customer" id="filter-customer">
                        <multiselect v-model="filter.customer"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optCustomer"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Gudang" id="filter-warehouse">
                        <multiselect v-model="filter.warehouse"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optWarehouse"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group id="filter-start-date" label="Tgl. Retur Dari">
                        <b-form-input id="start-date" type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group id="filter-end-date" label="Tgl. Retur Sampai">
                        <b-form-input id="end-date" type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group id="filter-actions" label="Aksi">
                        <b-button id="search-button" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                        <b-button id="calculate-button" class="ml-2" variant="dark" @click="calculateTotal()">
                            <i class="fa fa-calculator mr-2" />Total
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table id="retur-table" bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data retur.
                </template>
                <template v-slot:cell(no_faktur)="row">
                    {{ row.item.no }}
                    <div id="ref-no-faktur" class="small text-muted">
                        Ref. <strong>{{ row.item.invoice.no_faktur }}</strong>
                    </div>
                </template>
                <template v-slot:cell(refund)="row">
                    Rp. {{ $helper.formatThousand(row.item.refund) }}
                    <div id="customer-name" class="small font-weight-bold">
                        {{ row.item.invoice.customer_name }}
                    </div>
                </template>
                <template v-slot:cell(warehouse_name)="row">
                    {{row.item.invoice.from_warehouse.name}}<br />
                    <div id="office-name">{{row.item.office_name}}</div>
                </template>
                <template v-slot:cell(created_at)="row">
                    {{ $helper.parseDate(row.item.created) }}, {{ $helper.parseHourMinute(row.item.created) }}
                    <div id="created-by" class="small text-muted">
                        {{ row.item.created_by.fullname }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button id="list-barang-retur" variant="primary" size="sm" v-b-tooltip.hover.top title="List Barang Retur" @click="displayModalItems(row.item.id)">
                        <i class="fa fa-fw fa-list" />
                    </b-button>
                    <b-button id="reprint-invoice" variant="dark" class="ml-2" size="sm" v-b-tooltip.hover.top title="Reprint Invoice" @click="prepareReprint(row.item.id)">
                        <i class="fa fa-fw fa-print" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-reprint-code" title="Reprint" centered no-close-on-backdrop hide-footer @shown="$refs.passcode.focus()">
            <b-form-group id="reprint-passcode-group" label="Passcode Reprint">
            <b-form-input id="reprint-passcode-input" type="password" ref="passcode" maxlength="10" v-model="passcode" @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div id="reprint-passcode-actions" class="mt-4 text-right">
            <b-button id="reprint-passcode-button" variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                {{ isSubmitting ? "Mengambil..." : "Reprint" }}
            </b-button>
            </div>
        </b-modal>
        <b-modal id="m-reprint-barcode" title="Reprint Barcode" no-close-on-backdrop no-close-on-esc hide-footer hide-header-close>
            Silahkan cetak invoice dibawah ini. Mohon pastikan invoice tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe id="invoice-iframe" :src="$BASE_PRINT_FILE_PATH + getInvoiceLink()" height="300px" width="100%" />
            <div id="reprint-barcode-actions" class="mt-3">
            <b-row>
                <b-col md="6">
                <b-button id="toggle-invoice-size" variant="dark" :disabled="invoiceSizeCooldown" @click="toggleInvoiceSize">
                    Print {{ invoiceSize == 'A5' ? 'A4' : 'A5' }}
                </b-button>
                </b-col>
                <b-col md="6" class="text-right">
                <b-button id="close-reprint-barcode" variant="primary" @click="$bvModal.hide('m-reprint-barcode')">
                    Tutup
                </b-button>
                </b-col>
            </b-row>
            </div>
        </b-modal>
        <b-modal id="m-items" title="Barang Retur" size="lg" hide-footer no-close-on-backdrop no-close-on-esc>
            <ModalItemRetur :returnId="activeId" />
        </b-modal>
        <b-modal id="m-calculate" title="Perhitungan Totalan" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.customer != null">
                    Customer: <strong>{{ calculateTotalData.customer }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Invoice: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang Retur: <strong>{{ calculateTotalData.total_items }}</strong> barang<br />
                Total Refund: <strong>Rp. {{ $helper.formatThousand(calculateTotalData.total_price) }}</strong>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalItemRetur from './ModalItemRetur.vue'
export default {
    components: {
        ModalItemRetur
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            calculateTotalData: {},

            activeId: 0,
            passcode: "",
            link: "",
            linkA4: "",

            filter: {
                noFaktur: "",
                startDate: "",
                endDate: "",
                customer: null,
                warehouse: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no_faktur", label: "No. Faktur Retur", sortable: true },
                { key: "refund", label: "Refund", sortable: true },
                { key: "amount", label: "Jumlah Barang", sortable: true },
                { key: "warehouse_name", label: "Gudang", sortable: true },
                { key: "created_at", label: "Retur pada / oleh", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optCustomer: [],
            optWarehouse: [],

            invoiceSize: 'A5',
            invoiceSizeCooldown: false,

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getCustomers = this.$axios.get("customer/selection").then(res => {
                this.optCustomer = res.data.data
            })

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                res.data.data.map(item => {
                    this.optWarehouse.push({
                        id: item.id,
                        name: item.name + " - " + item.office_name
                    })
                })
            })

            Promise.all([getItems, getCustomers, getWarehouses]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(this.filter.warehouse != null) {
                param += "&filterWarehouse=" + this.filter.warehouse.id
            }

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("returns" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listReturFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        prepareReprint(id) {
            this.activeId = id
            this.$bvModal.show("m-reprint-code")
        },

        getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.activeId,
                passcode: this.passcode
            }

            this.$axios.post("returns/reprint", payload).then(res => {

                this.link = res.data.data.link
                this.linkA4 = res.data.data.linka4
                this.$bvModal.hide("m-reprint-code")
                this.$bvModal.show("m-reprint-barcode")
                this.passcode = ""

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        calculateTotal() {

            // Cek minimal tanggal terisi atau customer terisi
            let customerFilled = this.filter.customer != null
            let dateFilled = this.filter.startDate != "" || this.filter.endDate != ""

            if(!customerFilled && !dateFilled) {
                return this.$helper.toastError(this, "Mohon mengisi minimal filter customer atau tanggal penjualan!")
            }

            let param = ""

            if(this.filter.customer != null) {
                param += "&filterCustomer=" + this.filter.customer.id
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            this.isSubmitting = true
            this.$bvModal.show("m-calculate")

            this.$axios.get("returns/calculate?" + param).then(res => {
                this.calculateTotalData = res.data.data
                // sessionStorage.setItem("listReturFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("m-calculate")
            })
            .finally(() => this.isSubmitting = false)

        },

        displayModalItems(id) {
            this.activeId = id
            this.$bvModal.show("m-items")
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getInvoiceLink() {
            if(this.invoiceSize == 'A5'){
                return this.link
            }
            else{
                return this.linkA4
            }
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true
            if(this.invoiceSize == 'A5') this.invoiceSize = 'A4'
            else this.invoiceSize = 'A5'
            setTimeout(function(){
                this.invoiceSizeCooldown = false
            }.bind(this),2000);
        },

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listReturFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listReturFilter"))
        }
        this.init()
    }
}
</script>
